export type ProductReviewSort = 'newest' | 'helpful' | 'rating'
export type ProductReviewVariantFilter = 'all' | 'current'
export type ProductReviewVote = 'like' | 'dislike'
export type ProductReviewShop = 'h-store' | 'iport' | 'samsung'

export type ProductReviewCriterion = {
	name: string
	rating: number
}

export type ProductReviewMedia = {
	uuid: string
	src: string
}

export type ProductReview = {
	id: string
	productCode?: number
	productHref?: string
	isUserReview?: boolean
	verified?: boolean
	active: boolean
	author: string
	createdAt: string
	rating: number
	comment: string
	photos: string[]
	media: ProductReviewMedia[]
	likes: number
	dislikes: number
	isCurrentVariant: boolean
	shop?: ProductReviewShop
	shopUrl?: string
	userVote?: ProductReviewVote | null
}

export type ReviewMediaItem = {
	id: string
	src: string
	photoIndex: number
	review: ProductReview
	reviewId?: string
}

export type ProductReviewVariant = {
	id: ProductReviewVariantFilter
	name: string
	image?: string
	images?: string[]
}

export type ProductReviewsSummary = {
	average: number
	total: number
	distribution: Array<{ rating: number; count: number }>
	criteria: ProductReviewCriterion[]
}

export type ProductReviewsResponse = {
	summary: ProductReviewsSummary
	totalCount?: number
	variants: ProductReviewVariant[]
	gallery: string[]
	mediaItems?: ReviewMediaItem[]
	mediaTotal?: number
	mediaReviews?: ProductReview[]
	reviews: ProductReview[]
	hasMore: boolean
}

export type ProductReviewRatings = Record<string, { rating: number; count: number }>

export type UserReviewsResponse = {
	reviews: ProductReview[]
	hasMore: boolean
}

export type ProductReviewMediaResponse = {
	items: ReviewMediaItem[]
	total: number
	hasMore: boolean
	currentPage: number
}

export type GetProductReviewsParams = {
	productCode: string | number
	productCodes: Array<string | number>
	sort: ProductReviewSort
	variant: ProductReviewVariantFilter
	limit: number
	mediaLimit?: number
	currentPage: number
	isPhoto?: boolean
	isVideo?: boolean
	rating?: number[]
	reviewId?: number
	ratingOrder?: 'asc' | 'desc'
	productImages?: string[]
	token?: string
	cachedSummary?: ProductReviewsSummary
	includeSummary?: boolean
	includeMedia?: boolean
}

export type GetProductReviewMediaParams = Pick<
	GetProductReviewsParams,
	| 'productCode'
	| 'productCodes'
	| 'sort'
	| 'variant'
	| 'mediaLimit'
	| 'currentPage'
	| 'isPhoto'
	| 'isVideo'
	| 'rating'
	| 'ratingOrder'
	| 'reviewId'
	| 'token'
>

export type CreateProductReviewInput = {
	productCode: number
	productName?: string
	rating: number
	criteria: ProductReviewCriterion[]
	comment: string
	isAnonymous: boolean
	attachments: File[]
	token?: string
}
export type UpdateProductReviewInput = CreateProductReviewInput & {
	reviewId: string
	clearMedia?: string[]
}

export type VoteForProductReviewInput = {
	reviewId: string
	vote: ProductReviewVote
}

export class ProductReviewsApiError extends Error {
	status?: number
	validationMessage?: string

	constructor(message: string, status?: number, validationMessage?: string) {
		super(message)
		this.name = 'ProductReviewsApiError'
		this.status = status
		this.validationMessage = validationMessage
	}
}
